import { makeIsoDate, parseIsoDate } from "./date.helpers";


export const getDateFieldValue = function (value) {
    if (value === '') {
        return null;
    }

    var dateSpec = parseIsoDate(value);

    if (!dateSpec) {
        //Return -1 to match this value and throw error
        return "-1";
    }

    dateSpec.omitMilliseconds = true;

    return makeIsoDate(dateSpec);
};


export const getPersonValues = (nodes, options) =>
    nodes
        .map((n) => n.selectSingle('pc:AccountId', options))
        .map((n) => n?.value())
        .filter(Boolean);

